import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiCall } from '../../api/apiConfig';

export const simplifySentence = createAsyncThunk(
    'simplifier/simplifySentence',
    async ({ sentence, targetLevel }, { rejectWithValue }) => {
        try {
            const response = await apiCall('/simplify-sentence', 'POST', { text: sentence, targetLevel }); if (response.error) {
                return rejectWithValue(response.message || response.error);
            }
            return response;
        } catch (error) {
            return rejectWithValue('Error simplifying sentence');
        }
    }
);

const simplifierSlice = createSlice({
    name: 'simplifier',
    initialState: {
        lastSimplified: null,
        loading: false,
        error: null,
    },
    reducers: {
        clearSimplifier: (state) => {
            state.lastSimplified = null;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(simplifySentence.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(simplifySentence.fulfilled, (state, action) => {
                state.loading = false;
                state.lastSimplified = action.payload.simplified;
            })
            .addCase(simplifySentence.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'An unexpected error occurred';
            });
    },
});

export const { clearSimplifier } = simplifierSlice.actions;
export default simplifierSlice.reducer;
